import { MapContainer, TileLayer, Marker, Popup, useMapEvents, useMap } from 'react-leaflet';
//import 'leaflet/dist/leaflet.css';
import React, { Fragment, useEffect } from 'react';
import { SURVEYS_BY_LOC, SURVEYS_BY_MAP, SURVEYS_NO_LOC, WITHIN_RAD } from '../App';
import LoadingSpinner from './LoadingSpinner';
import L from 'leaflet';
import BEEICON from "./bee-icon-myLoc.png"


// Defined outside TasksMap so it is not recreated on every render
function MyMap() {
    useMapEvents({
        dragend: (e) => {
            // mapCenter update is local only; re-fetching tasks on drag is not yet implemented
            void e.target.getCenter();
        }
    })
    return null
}

// Close the open popup as soon as user tries to scroll (capture phase, before Leaflet blocks it)
function ClosePopupOnScroll() {
    const map = useMap();
    useEffect(() => {
        const closePopup = () => {
            if (map.isPopupOpen()) map.closePopup();
        };
        const opts = { capture: true, passive: true };
        document.addEventListener('wheel', closePopup, opts);
        document.addEventListener('touchmove', closePopup, opts);
        return () => {
            document.removeEventListener('wheel', closePopup, opts);
            document.removeEventListener('touchmove', closePopup, opts);
        };
    }, [map]);
    return null;
}


function TasksMap({ tasks_by_loc, isLoaded, onActivateLoc, toogleClick, mapCenter, myLoc, update_distance}) {



    const customIcon = new L.icon ({
        iconUrl: BEEICON,
        iconSize: [30, 30],
        })


    if (mapCenter.lat === null) mapCenter = myLoc

    let upd_tbl = []
    upd_tbl = update_distance (tasks_by_loc)



    if (isLoaded === false || !tasks_by_loc?.length) {
        return <LoadingSpinner message={!tasks_by_loc?.length ? 'No hay tareas cerca.' : 'Cargando tareas…'} />
    } else {
        return (
            <Fragment>
                <nav className="navbar-light bg-light py-2 border-bottom d-flex justify-content-between align-items-center px-2" >
                    <span className="navbar-brand mb-0 h6">Tareas</span>
                    <div className="btn-group" role="group" data-toggle="buttons">
                        <button type="button" className="btn btn-sm btn-outline-secondary"
                            onClick={() => toogleClick(SURVEYS_BY_LOC)}>List</button>
                        <button type="button" className="btn btn-sm btn-outline-secondary active"
                            onClick={() => toogleClick(SURVEYS_BY_MAP)}>Map</button>
                    </div>
                </nav>
                <div id="map">
                    <MapContainer
                        center={[mapCenter.lat, mapCenter.lon]}
                        zoom={15} scrollWheelZoom={false}
                        closePopupOnClick={false}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <MyMap />
                        <ClosePopupOnScroll />

                        <Marker position={[myLoc.lat, myLoc.lon]} icon= {customIcon}>
                            <Popup><h3>{"Este eres tu!"} </h3></Popup>
                            </Marker>


                        {upd_tbl.map((loc, index) => (
                            <Marker key={loc.loc_scope ?? `noloc-${index}`} position={[loc.loc_lat, loc.loc_lon]}>
                                <Popup>
                                    <div>
                                        <h6 className="mb-1">{loc.loc_name}</h6>
                                        <div className="small text-muted">
                                            Distancia: {loc.loc_distance} mts<br />
                                            {loc.loc_distance >= WITHIN_RAD ? 'Debe acercarse  para poder activar' : ""}
                                        </div>
                                        {loc.loc_surveys.map(svy => (
                                            <p key={svy.svy_loc_scope_pk} className="mb-1 small">
                                                <strong>{svy.survey_title}</strong><br />
                                                {svy.surveys_to_complete - svy.surveys_completed} encuesta
                                                {(svy.surveys_to_complete - svy.surveys_completed) > 1 ? 's' : ''} por completar
                                            </p>
                                            ))}
                                    </div>
                                    <div className="position-relative center">
                                        <button onClick={() => onActivateLoc(index)}
                                          //  disabled={(loc.loc_distance >= WITHIN_RAD)}
                                            className="btn btn-primary btn-sm btn-block m-2">Activar</button>
                                    </div>
                                </Popup>
                            </Marker>
                        ))}
                    </MapContainer>

                </div>
            </Fragment>
        )
    }
}




export default TasksMap;

//<button onClick={() => this.refreshLocs(this.refs.map.getCenter().latitude,
//    this.refs.map.getBounds().longitud)}
//className="btn btn-primary btn-sm btn-block m-2">Refrescar</button>
